import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { DndDirective } from './directives/dnd.directive';
import { FormsModule } from '@angular/forms';
import { FactParameterComponent } from './components/fact-parameter/fact-parameter.component';
import { SkillListComponent } from './components/skill-list/skill-list.component';
import { IsNullOrEmptyPipe } from './pipes/is-null-or-empty.pipe';
import { ChipListComponent } from './components/chip-list/chip-list.component';



@NgModule({
  declarations: [
    DndDirective,
    FactParameterComponent,
    SkillListComponent,
    IsNullOrEmptyPipe,
    ChipListComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  exports: [
    DndDirective,
    FactParameterComponent,
    SkillListComponent,
    ChipListComponent,
    IsNullOrEmptyPipe]
})
export class SharedModule { }
